import { Button, Card, CardContent, Stack, Typography, Chip } from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import { usePWA } from '@/hooks/usePWA';

export function PWAStatus() {
  const { isInstallable, isInstalled, isOnline, hasUpdate, isUpdating, install, update } = usePWA();

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h6">Estado de la Aplicación</Typography>

          <Stack direction="row" spacing={1} flexWrap="wrap">
            {/* Installation Status */}
            <Chip
              icon={isInstalled ? <CheckCircleIcon /> : undefined}
              label={isInstalled ? 'Instalado' : 'No instalado'}
              color={isInstalled ? 'success' : 'default'}
              variant="outlined"
            />

            {/* Online Status */}
            <Chip
              icon={isOnline ? <CloudDownloadIcon /> : <CloudOffIcon />}
              label={isOnline ? 'En línea' : 'Sin conexión'}
              color={isOnline ? 'success' : 'warning'}
              variant="outlined"
            />

            {/* Update Status */}
            {hasUpdate && (
              <Chip
                icon={<CloudDownloadIcon />}
                label="Actualización disponible"
                color="warning"
                variant="outlined"
              />
            )}
          </Stack>

          <Stack direction="row" spacing={1}>
            {isInstallable && !isInstalled && (
              <Button variant="contained" startIcon={<GetAppIcon />} onClick={install}>
                Instalar aplicación
              </Button>
            )}

            {hasUpdate && (
              <Button
                variant="contained"
                color="warning"
                startIcon={<CloudDownloadIcon />}
                onClick={update}
                disabled={isUpdating}
              >
                {isUpdating ? 'Actualizando...' : 'Actualizar ahora'}
              </Button>
            )}
          </Stack>

          <Typography variant="caption" color="text.secondary">
            {isInstalled
              ? 'La aplicación está instalada y puede usarse sin conexión.'
              : 'Instala la aplicación para acceder sin conexión y una mejor experiencia.'}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
}
